import { FeatureFlags } from '@frontegg/rest-api';
import { useShadowDom } from '../common';
export const useFeatureFlags = flags => {
  const {
    injector
  } = useShadowDom();
  return FeatureFlags.getFeatureFlags(flags, injector.name);
};
export const useFeatureFlagsChecker = () => {
  const {
    injector
  } = useShadowDom();
  return flags => {
    return FeatureFlags.getFeatureFlags(flags, injector.name);
  };
};